import styled from '@emotion/styled';
import { Prismic, PrismicText } from '@landsbankinn/prismic';
import { Reveal, Segment } from '@landsbankinn/ui';
import React from 'react';
import { MoreInfoCardGroup } from '../components/card-group/MoreInfoCardGroup';
import { MoreInfoCard } from '../components/card/MoreInfoCard';

interface IProps {
  title: Prismic.RichText;
  fields: IField[];
  expandable: boolean;
}

interface IField {
  image: Prismic.Image;
  title: Prismic.RichText;
  copy: Prismic.RichText;
  index: number;
  expandable: boolean;
}

const Background = styled(Reveal)`
  background-color: ${(props) => props.theme.colors.backgroundAlt};
  margin-bottom: 60px;
`;

const Spacing = styled(Segment)`
  position: relative;
  > div {
    position: initial;
  }
`;

export const MoreInfoContainer = ({ fields, expandable, title }: IProps) => {
  if (fields?.length === 0) {
    return null;
  }
  // Check if first of three childs has image
  const firstThree = fields?.slice(0, 3).map(({ image }) => !!image);
  const childHasImage = firstThree.includes(true);

  return (
    <Background>
      <Spacing>
        <MoreInfoCardGroup
          title={Prismic.text(title)}
          columns={3}
          isCollapsed={expandable}
          hasImage={childHasImage}
        >
          {fields?.map((item, index) => (
            <MoreInfoCard
              key={`info-card-item-${index}`}
              image={item.image}
              ar="ar_1_1"
              title={Prismic.text(item.title)}
              description={<PrismicText value={item.copy} />}
              isCollapsed={item.expandable}
              index={item.index}
            />
          ))}
        </MoreInfoCardGroup>
      </Spacing>
    </Background>
  );
};
